import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track5ABlue = ({ state, workState, onLabelClick }) => {
	const trackParams = {
		stroke: getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE),
		strokeWidth: tracksWidth,
		strokeLinecap: "round"
	};

	return (
		<g id="Track5ABlue" transform="translate(1461.000000, 620.000000)" className="track">
			<path
				d="M275.002103,150.991139 L315.209589,134.458376 C362.168284,115.14961 396.171707,73.3963248 405.572336,23.500677 L410,0 L410,0"
				{...trackParams}/>

			<path
				d="M275.261676,150.87935 L78.4345209,234.264212 M67.5332058,238.882501 L31.8576544,253.996274 C20.5434537,258.78948 7.48582083,253.503169 2.69261502,242.188968 C0.604869113,237.260914 0.363522439,231.745429 2.01282913,226.653849"
				{...trackParams}/>

			<TrackArrow transform="translate(81.010548, 233.218816) rotate(-386.000000) translate(-81.010548, -233.218816) "
									points="85.0105481 241.218816 77.0105481 233.218816 85.0105481 225.218816"
									strokeColor={trackParams.stroke}/>

			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track5ABlue')}
				coords="114.301017, 195.677286"
				text="5A"
				textCoordsX="10.1567383"
				colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			/>
		</g>)
};

Track5ABlue.propTypes = trackPropTypes;

export default Track5ABlue;